import {useMutation, gql} from '@apollo/client'

const useUploadPdfBase64Mutation = (onSuccess = () => {}, onError = () => {}) => {
    return useMutation(
        gql`
            mutation (
                $bucket: String!
                $file: String!
            ) {
                uploadPdfBase64 (
                    bucket: $bucket
                    file: $file
                )
            }
        `,
        {
            onCompleted: (result) => {
                onSuccess(result)
            },
            onError
        }
    )
}

export default useUploadPdfBase64Mutation  